import { getApiBaseUrl } from '../hooks/useFetch';

const triggerBrowserDownload = (href) => {
  const anchor = document.createElement('a');
  anchor.href = href;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
}

// The API sends Content-Disposition: attachment for these URLs, so the
// browser downloads in place without navigating away.
export const downloadAssetFile = (file) => {
  const separator = file.url.indexOf('?') > -1 ? '&' : '?';
  triggerBrowserDownload(`${file.url}${separator}download=true`);
}

export const downloadAssetFolder = (prefix = '') => {
  triggerBrowserDownload(`${getApiBaseUrl()}/asset/manage/folder/download?prefix=${encodeURIComponent(prefix)}`);
}
